function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{display:none;fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st1{fill:#EA4335;}\n\t.st2{fill:#4285F4;}\n\t.st3{fill:#FBBC05;}\n\t.st4{fill:#34A853;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0,24C0,10.7,10.7,0,24,0s24,10.7,24,24S37.3,48,24,48S0,37.3,0,24z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M24.5,9.3c4.6,0,7.7,1.9,9.5,3.6l6.9-6.6C36.6,2.4,31.1,0,24.5,0C14.9,0,6.6,5.4,2.6,13.2l7.9,6 C12.5,13.5,18,9.3,24.5,9.3z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M48,24.5c0-2-0.2-3.4-0.5-4.9h-23v8.9H38c-0.3,2.2-1.7,5.5-5,7.8l7.7,5.9C45.3,38,48,31.8,48,24.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M10.6,28.7c-0.6-1.4-0.9-3-0.9-4.7s0.3-3.3,0.8-4.7l-7.9-6C1,16.5,0,20.1,0,24s1,7.5,2.6,10.8L10.6,28.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M24.5,48c6.6,0,12.2-2.1,16.2-5.8L33,36.3c-2.1,1.4-4.8,2.4-8.5,2.4c-6.5,0-12-4.2-13.9-10l-7.9,6 C6.7,42.6,14.9,48,24.5,48z"
});

var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google.064802ff.svg";
export { ForwardRef as ReactComponent };